import { Component, Input, OnInit } from '@angular/core';
import { SkeletonSizeBase } from '../../../common';

@Component({
  selector: 'skc-card-meta',
  templateUrl: './card-meta.component.html',
  styleUrls: ['./card-meta.component.less']
})
export class CardMetaComponent extends SkeletonSizeBase implements OnInit {
  @Input() borderRadius = '0';
  @Input() height = '300px';
  @Input() width = '100%';
  constructor() {
    super();
  }

  ngOnInit() {}
}
